<router-outlet class="h100">
  <app-alert></app-alert>
</router-outlet>
<!-- Routed components go here -->
